module.exports = __webpack_public_path__ + "static/media/chessjsImage.6ef90461.svg";